import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';

//import Discussion from './Discussion';
import Discussion from './DiscussionLazy';
import { preloadDiscussionChunk } from './DiscussionLazy';
import SkeletonDiscussion from "./SkeletonDiscussion";
import { decryptMessage } from '../services/signalSession';
import {
  getCachedDecryption,
  setCachedDecryption, signalStore, purgeMessageCaches
} from '../services/signalStore';

import { decryptOne } from '../services/messageDecrypt';
import { decryptGroupMessage, resetGroupKeyState } from '../services/signalGroupCrypto';
import { SignalProtocolAddress } from '@privacyresearch/libsignal-protocol-typescript';

import CreateDiscussion from './CreateDiscussion';
import DiscussionInfoModal from './DiscussionInfoModal';
import { useNavigate } from 'react-router-dom';
import OnlineUsersFooter from './OnlineUsersFooter';
import ImportContacts from './ImportContacts';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import api from '../services/api';
import { fetchMessagesForDiscussion } from "../services/messages";
import { onMessage } from "firebase/messaging";
import { useDiscussions } from "./DiscussionsContext";
import  usePreloadDiscussions  from "../services/usePreloadDiscussions";
import { decryptDiscussionFields, openGroupKeyCacheDB, getGroupKeyForDiscussion, rewrapGroupKeyForParticipant, deleteCachedGroupKey } from '../services/signalGroupCrypto';
import { withSignalLock } from '../services/signalSession';
import { fulfilAllPending } from '../services/historyRepair';

const getToken = () => localStorage.getItem('token') || '';

const DiscussionList = ({ socket, email, notifications, setNotifications, userObj, prompt, selectedDiscussion, setSelectedDiscussion, startVideoCall, setCallInProgress}) => {
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
const [decryptedTitles, setDecryptedTitles] = useState({});
	const { discussions, setDiscussions } = useDiscussions();

	const [isClosing, setIsClosing] = useState(false);
	const [openDiscussionId, setOpenDiscussionId] = useState(null);
	const [showForm, setShowForm] = useState(false);
	const navigate = useNavigate();
	const [onlineUsers, setOnlineUsers] = useState([]);
	const [contacts, setContacts] = useState(() => {
	const stored = localStorage.getItem('contacts');
  	return stored ? JSON.parse(stored) : [];
	});
	
const [lastMessages, setLastMessages] = useState({});
const [decryptedPreviews, setDecryptedPreviews] = useState({});
const messagesCacheRef = useRef({});

const [loadingDiscussions, setLoadingDiscussions] = useState(false);

const [loadingDiscussion, setLoadingDiscussion] = useState(false);

const handleDiscussionLoadStart = useCallback(() => {
  setLoadingDiscussion(true);
}, []);

const handleDiscussionLoadEnd = useCallback(() => {
  setLoadingDiscussion(false);
}, []);

const { messagesCache, setMessagesCache, loading: loadingPreload } = usePreloadDiscussions(discussions);

const [openAgenda, setOpenAgenda] = useState(false);
const [highlightEventId, setHighlightEventId] = useState(null);

const token = localStorage.getItem('token') || "";
const user = JSON.parse(localStorage.getItem('user'));


const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

useEffect(() => {
  if (!socket) return;

  const onExpired = ({ discussionId, ids }) => {
    purgeMessageCaches(ids).catch(() => {});
    setLastMessages((prev) =>
      ids.includes(prev[discussionId]?._id) ? { ...prev, [discussionId]: null } : prev
    );
  };

  socket.on('messagesExpired', onExpired);
  return () => socket.off('messagesExpired', onExpired);
}, [socket]);

useEffect(() => {
  if (!socket) return;

  const handleStatus = (data) => {
   
setOnlineUsers(prev =>
      prev.map(u => (u._id === data._id ? { ...u, isConnected: data.isConnected } : u))
    );
  };

  socket.on("userStatusChanged", handleStatus);
  return () => socket.off("userStatusChanged", handleStatus);
}, [socket]);


useEffect(() => {
  messagesCacheRef.current = messagesCache;
}, [messagesCache]);



//gestion de l'affichage des derniers messages

const fetchOverview = useCallback(async ({ force = false } = {}) => {
  try {
    const { data } = await api.get(`${API_URL}/api/messages/overview`,
      { headers: { Authorization: `Bearer ${getToken()}` } });

    const byId = {};
    data.forEach(m => {
      const id = String(m.discussion || m.discussionId || '');
      if (id) byId[id] = m;
    });

    setLastMessages(prev => {
      const next = { ...prev };
      if (force) {
        // la réponse serveur fait foi, y compris pour "plus aucun message"
        discussions.forEach(d => { next[d._id] = byId[String(d._id)] || null; });
        return next;
      }
      Object.entries(byId).forEach(([id, m]) => {
        const old = next[id];
        if (!old || new Date(m.createdAt) >= new Date(old.createdAt)) next[id] = m;
      });
      discussions.forEach(d => { if (next[d._id] === undefined) next[d._id] = null; });
      return next;
    });
  } catch (err) {
    console.error('Erreur overview :', err?.message);
  }
}, [discussions]);

// au chargement / changement de la liste
useEffect(() => {
  if (discussions.length) fetchOverview();
}, [discussions, fetchOverview]);

// resynchronisation : reconnexion socket, retour au premier plan
useEffect(() => {
  if (!socket) return;
  const onVisible = () => {
    if (document.visibilityState === 'visible') fetchOverview();
  };
  socket.on('connect', fetchOverview);              // inclut les reconnexions
  document.addEventListener('visibilitychange', onVisible);
  document.addEventListener('resume', fetchOverview); // Cordova
  return () => {
    socket.off('connect', fetchOverview);
    document.removeEventListener('visibilitychange', onVisible);
    document.removeEventListener('resume', fetchOverview);
  };
}, [socket, fetchOverview]);

useEffect(() => {
  if (!socket) return;


  const handleLastMessage = (msg) => {

    const discussionId = String(msg?.discussion || msg?.discussionId || '');
    if (!discussionId || msg.confidential?.isConfidential) return;

    setLastMessages(prev => {
      const old = prev[discussionId];
      if (old && new Date(old.createdAt) > new Date(msg.createdAt)) return prev;
      return { ...prev, [discussionId]: msg };
    });
  };

  socket.on('lastMessageUpdate', handleLastMessage);

  return () => socket.off('lastMessageUpdate', handleLastMessage);

}, [socket]);

//const user = JSON.parse(localStorage.getItem('user'));
const userId = user?._id || user?.id;

const { t } = useTranslation();
const getDecryptedMessagePreview = async (msg, userId, t) => {
  if (!msg) {
    return { senderName: '', preview: '' };
  }

  // Messages confidentiels : rien dans l'aperçu
  if (msg.confidential?.isConfidential) {
    return { senderName: '', preview: '' };
  }

  const isMe =
    String(msg.sender?._id || msg.sender) === String(userId);
//const senderName = isMe ? t('discussion.me') : (msg.sender?.username || '?');
  const senderName = isMe
    ? t('discussion.me')
    : (msg.sender?.username || '?');

  // ==========================================================
  // MESSAGE E2EE
  // ==========================================================

  if (msg.e2ee && msg.text && msg.e2eeData) {
  try {
    const decryptedText = await decryptOne(msg, String(userId));

    if (!decryptedText) {
      return { senderName, preview: '🔐 Message' };
    }
    return {
      senderName,
      preview: decryptedText.slice(0, 60) + (decryptedText.length > 60 ? '…' : ''),
    };
  } catch (error) {
    console.error('Aperçu E2EE non déchiffré :', msg._id, error?.message);
    return { senderName, preview: '🔐 Message' };
  }
}

  // ==========================================================
  // MESSAGE CLASSIQUE
  // ==========================================================

  if (msg.text) {
    return {
      senderName,
      preview:
        msg.text.slice(0, 60) +
        (msg.text.length > 60 ? '…' : '')
    };
  }

  // ==========================================================
  // PIÈCES JOINTES
  // ==========================================================

  if (
    msg.files &&
    Object.keys(msg.files).length > 0
  ) {
    const fileKey =
      Object.keys(msg.files).find(
        key => msg.files[key] != null
      );

    const fileObj = msg.files[fileKey];

    if (fileObj) {
      const mimeType =
        fileObj.mimeType || '';

      if (mimeType.startsWith('image/')) {
        return {
          senderName,
          preview: `🖼️ ${t('file_panel.image')}`
        };
      }

      if (mimeType.startsWith('video/')) {
        return {
          senderName,
	preview: `🎥 ${t('file_panel.video')}`
          
        };
      }

      if (mimeType.startsWith('audio/')) {
        return {
          senderName,
	preview: `🎵 ${t('file_panel.audio')}`
          
        };
      }

      return {
        senderName,
	preview: `📎 ${t('file_panel.document')}`
      
      };
    }
  }

  return {
    senderName,
    preview: ''
  };
};


useEffect(() => {
  let cancelled = false;

  const decryptPreviews = async () => {
    const entries = Object.entries(lastMessages);
const realEntry = entries.find(([id, msg]) => msg && !msg.confidential?.isConfidential);
if (realEntry) {
  const [id, msg] = realEntry;
  
  try {
    const direct = await getDecryptedMessagePreview(msg, userId, t);
      } catch (e) {
    
  }
}

    // ⚡ Parallélisé : plus de boucle for séquentielle avec await
    const resultsArray = await Promise.all(
      entries.map(async ([discussionId, msg]) => {
        if (!msg) {
          return [discussionId, { senderName: '', preview: '' }];
        }
        const preview = await getDecryptedMessagePreview(msg, userId, t);
        return [discussionId, preview];
      })
    );

    if (!cancelled) {
      setDecryptedPreviews(Object.fromEntries(resultsArray));
    }
  };

  decryptPreviews();

  return () => {
    cancelled = true;
  };
}, [lastMessages, userId, t]);


useEffect(() => {
  if (!socket) return;

  const handleNewMessage = (newMessage) => {
  const msg = newMessage.dataToSend || newMessage;

//const discussionId = msg.discussionId || msg.discussion;
const discussionId = String(msg.discussion || msg.discussionId || '');
  if (!discussionId || !msg) return;
  if (msg.confidential?.isConfidential) return;

  setLastMessages(prev => ({
    ...prev,
    [discussionId]: msg
  }));
};

  socket.on('receiveMessage', handleNewMessage);
  return () => socket.off('receiveMessage', handleNewMessage);
}, [socket]);

useEffect(() => {
  if (!socket) return;

  const handleSessionReset = async ({ fromUserId }) => {
    if (!fromUserId) return;
    const addr = new SignalProtocolAddress(String(fromUserId), 1).toString();
    try {
      // sous verrou : ne pas casser un envoi/déchiffrement en cours avec ce contact
      await withSignalLock(addr, async () => {
        await signalStore.remove(`session_${addr}`);
      });
      socket.emit('session-reset-done', { targetUserId: fromUserId });
    } catch (err) {
      console.error('Erreur reset session:', err);
    }
  };

  socket.on('session-reset-requested', handleSessionReset);
  return () => socket.off('session-reset-requested', handleSessionReset);
}, [socket]);

useEffect(() => {
  if (!socket) return;

  const handleGroupKeyRepaired = async ({ discussionId }) => {
    resetGroupKeyState(discussionId);

    const fresh = await fetchDiscussionById(discussionId);       // contient le nouveau groupKeyWrap
    if (fresh) {
      setDiscussions((prev) => prev.map((d) => (d._id === fresh._id ? { ...d, ...fresh } : d)));
      setSelectedDiscussion((prev) => (prev && prev._id === fresh._id ? { ...prev, ...fresh } : prev));
    }

    // oublier le titre mémorisé : l'effet de déchiffrement des titres le recalcule
    setDecryptedTitles((prev) => {
      const next = { ...prev };
      delete next[discussionId];
      return next;
    });
  };

  socket.on('group-key-repaired', handleGroupKeyRepaired);
  return () => socket.off('group-key-repaired', handleGroupKeyRepaired);
}, [socket]);

useEffect(() => {
  if (!socket) return;

  const handleRepairRequest = async ({ discussionId, requesterId }) => {
    try {
      const discussionResponse = await api.get(`${API_URL}/api/discussions/${discussionId}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      const discussion = discussionResponse.data;

      const groupKeyRaw = await getGroupKeyForDiscussion(discussion, socket, userId);
      if (!groupKeyRaw) return; // moi-même pas synchronisé, je ne peux pas aider

      const wrap = await rewrapGroupKeyForParticipant(requesterId, groupKeyRaw);

      await api.put(
        `${API_URL}/api/discussions/${discussionId}/groupkeywrap`,
        {
          participantId: requesterId,
          encryptedKey: wrap.encryptedKey,
          keyIv: wrap.keyIv,
          keyType: wrap.keyType,
        },
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );

      socket.emit('group-key-repaired', { discussionId, targetUserId: requesterId });
    } catch (err) {
      console.error('Erreur réparation automatique:', err);
      // Un autre participant connecté prendra peut-être le relais
    }
  };

  socket.on('group-key-repair-requested', handleRepairRequest);
  return () => socket.off('group-key-repair-requested', handleRepairRequest);
}, [socket, userId]);

useEffect(() => {
  if (!socket) return;
  fulfilAllPending();                                  
  const h = () => fulfilAllPending();
  socket.on('repair-requested', h);
  return () => socket.off('repair-requested', h);
}, [socket]);

const handleNewMessagePreview = useCallback((discussionId, msg) => {
// ✅ Ignorer les messages confidentiels
  if (msg.confidential?.isConfidential) return;
  setLastMessages(prev => ({ ...prev, [discussionId]: msg }));
}, []);


const handleMessageUpdatedPreview = useCallback((discussionId, updatedMsg) => {
  setLastMessages((prev) => {
    const current = prev[discussionId];
    if (!current || current._id !== updatedMsg._id) return prev;
    return { ...prev, [discussionId]: { ...current, ...updatedMsg } };
  });
}, []);

useEffect(() => {
  if (!socket) return;
  const onUpdated = (updated) => {
    const discId = updated.discussion || updated.discussionId;
    setLastMessages((prev) =>
      prev[discId]?._id === updated._id ? { ...prev, [discId]: { ...prev[discId], ...updated } } : prev
    );
  };
  socket.on('messageUpdated', onUpdated);
  return () => socket.off('messageUpdated', onUpdated);
}, [socket]);


const lastMessagesRef = useRef({});
useEffect(() => { lastMessagesRef.current = lastMessages; }, [lastMessages]);

const handleDeletedMessagePreview = useCallback((discussionId, messageId) => {
  const current = lastMessagesRef.current[String(discussionId)];
  if (current && String(current._id) !== String(messageId)) return; // pas le dernier : rien à faire
  fetchOverview({ force: true });
}, [fetchOverview]);

useEffect(() => {
  if (!socket) return;
  const onRefresh = ({ discussion, messageId }) =>
    handleDeletedMessagePreview(discussion, messageId);
  socket.on('lastMessageRefresh', onRefresh);
  return () => socket.off('lastMessageRefresh', onRefresh);
}, [socket, handleDeletedMessagePreview]);

//fin de la gestion des derniers messages

//notifications

const discussionsRef = useRef(discussions);
const lastNotificationRef = useRef(null);
const handlePayloadRef = useRef(null);
const pendingPayloadRef = useRef(null);
const userIdRef = useRef(userId);

const notificationsRef = useRef(notifications);
useEffect(() => {
  notificationsRef.current = notifications;
}, [notifications]);

const removeInvitationCard = (discussionId) =>
  setNotifications((prev) => prev.filter((n) => String(n.discussionId) !== String(discussionId)));

useEffect(() => {
  if (!socket) return;

  const onCancelled = async ({ discussionId }) => {
    const notif = (notificationsRef.current || []).find(
      (n) => String(n.discussionId) === String(discussionId)
    );
    if (!notif) return;                                     // rien d'affiché, rien à retirer

    removeInvitationCard(discussionId);
    await prompt.alert(t('inviter.invitation_annulee', { name: notif.inviterName }));
  };

  socket.on('invitationCancelled', onCancelled);
  return () => socket.off('invitationCancelled', onCancelled);
}, [socket]);


useEffect(() => {
  discussionsRef.current = discussions;
}, [discussions]);

useEffect(() => {
  userIdRef.current = userId;
}, [userId]);

// Traite la notification de démarrage à froid dès que tout est prêt (n'utilise que des refs)
const flushPendingNotification = () => {
  if (!userIdRef.current || !pendingPayloadRef.current || !handlePayloadRef.current) return;
  const p = pendingPayloadRef.current;
  pendingPayloadRef.current = null;
  handlePayloadRef.current(p);
};

// 1) Enregistrement des écouteurs : UNE SEULE FOIS
useEffect(() => {
  const messaging = window?.cordova?.plugins?.firebase?.messaging;
  if (!messaging) return;

  const handlePayload = async (payload) => {
    try {
      let data = payload.data || payload.additionalData || {};
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch { data = {}; }
      }

      const type = data.type || payload.type || 'message';
      if (type === 'birthday') return;

      const discussionId = data.discussionId || payload.discussionId || data.id || payload.id;
      const inviterName = data.inviterName || payload.inviterName || 'Quelqu’un';
      const discussionTitle = data.discussionTitle || payload.discussionTitle || 'une discussion';
      const title = payload.notification?.title || data.title || '';
      const eventId = data.eventId || payload.eventId || '';
      const body = payload.notification?.body || data.body || '';

      // anti-doublon
      const notificationKey = `${type}_${discussionId}_${data.eventId || ''}_${title}_${body}`;
      if (lastNotificationRef.current === notificationKey) return;
      lastNotificationRef.current = notificationKey;
      setTimeout(() => { lastNotificationRef.current = null; }, 3000);

      if (title || body) {
        alert(`${title || ''}\n\n${body || ''}`);
      }
      if (!discussionId) return;

      if (type === 'message') {
        let discussion = discussionsRef.current.find((d) => String(d._id) === String(discussionId));
        if (!discussion) discussion = await fetchDiscussionById(discussionId);
        if (discussion) setSelectedDiscussion(discussion);

      } else if (type === 'invitation') {
        fetchDiscussions();
      setSelectedDiscussion(null);
      setNotifications(prev => [
        { discussionId, inviterName, discussionTitle, title, body, type },
        ...prev
      ]);

//  );

	} else if (type === 'invitation_cancelled') {
      removeInvitationCard(discussionId);
    

      } else if (type === 'new_event' || type === 'event_reminder') {
        let discussion = discussionsRef.current.find((d) => String(d._id) === String(discussionId));
        if (!discussion) discussion = await fetchDiscussionById(discussionId);

        if (discussion) {
          setSelectedDiscussion(discussion);
          setOpenAgenda(true);
          if (eventId) setHighlightEventId(eventId);
        }
      }
    } catch (err) {
      console.error('Erreur handlePayload :', err, payload);
    }
  };

  handlePayloadRef.current = handlePayload;

  messaging.onMessage(handlePayload);
  messaging.onBackgroundMessage(handlePayload);

  // Démarrage à froid : on mémorise, puis on traite quand userId est connu
  if (typeof messaging.getInitialNotification === 'function') {
    messaging.getInitialNotification()
      .then((payload) => {
        if (!payload) return;
        pendingPayloadRef.current = payload;
        flushPendingNotification();
      })
      .catch((err) => console.error('getInitialNotification err', err));
  }

  return () => {
    if (typeof messaging.offMessage === 'function') messaging.offMessage(handlePayload);
    if (typeof messaging.offBackgroundMessage === 'function') messaging.offBackgroundMessage(handlePayload);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

// 2) Si userId arrive APRÈS la notification de démarrage à froid
useEffect(() => {
  flushPendingNotification();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [userId]);

useEffect(() => { 
if (!socket) return;

const handleInvitation = (invitation) => { 

setNotifications(prev => [invitation, ...prev]); 
setSelectedDiscussion(null); // assure que la liste s'affiche 
fetchDiscussions(); // met à jour la liste 
}; 
socket.on("userInvited", handleInvitation); 
return () => { 
socket.off("userInvited", handleInvitation); 
}; 
}, [socket]); // ne pas inclure discussions ou autres states ici

const addInvitationCard = (invitation) =>
  setNotifications((prev) =>
    prev.some((n) => String(n.discussionId) === String(invitation.discussionId))
      ? prev
      : [invitation, ...prev]
  );

// Fonction pour ouvrir une discussion par ID (depuis notification)
const openDiscussionById = async (discussionId) => {

  // On recherche dans les discussions locales
  let discussion = discussions.find(d => d._id === discussionId);

  // Si non trouvée, on charge depuis l’API
  if (!discussion) {
   
    discussion = await fetchDiscussionById(discussionId); // ⚡ correction ici
  }

  if (discussion) {
  preloadDiscussionChunk();
    setSelectedDiscussion(discussion); // ✅ ouvre le fullscreen
  } else {
    console.warn("❌ Impossible de trouver ou charger la discussion !");
  }
};

//fin notifications

const fetchDiscussionById = async (id) => {
  try {
    const response = await api.get(`${API_URL}/api/discussions/${id}`, {
      headers: { Authorization: `Bearer ${getToken()}` },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors du chargement de la discussion :', error?.response?.status || error.message);
    return null;
  }
};


const updateContactsStatus = useCallback(async () => {
  const storedContacts = JSON.parse(localStorage.getItem('contacts') || '[]');
  try {
    const response = await api.post(`${API_URL}/api/list_users/online-contacts`, {
      contacts: storedContacts,
      currentUserEmail: userObj?.email,
    });
    setOnlineUsers(response.data);
  } catch (err) {
    console.error('Erreur contacts connectés:', err);
  }
}, [API_URL, userObj?.email]);

useEffect(() => {
  if (!socket || !userObj?.email) return;

  // 1️⃣ Initial fetch
  updateContactsStatus();

  // 2️⃣ Attacher une seule fois le listener
  //socket.off("userStatusChanged"); // supprime ancien si existe
  socket.on("userStatusChanged", updateContactsStatus);

  // 3️⃣ Nettoyage
  return () => socket.off("userStatusChanged", updateContactsStatus);
}, [socket, updateContactsStatus, userObj?.email]);

const handleStatusChange = (userId, isConnected) => {
  setContacts(prev =>
    prev.map(u => (u._id === userId ? { ...u, isConnected } : u))
  );
};

  
const fetchDiscussions = useCallback(async () => {
  setLoadingDiscussions(true);
  try {
    const storedContacts = JSON.parse(localStorage.getItem('contacts') || '[]');
    const contactEmails = storedContacts
      .filter(c => c.email)
      .map(c => c.email.trim().toLowerCase());

    const response = await api.get(`${API_URL}/api/discussions`, {
      params: { contactEmails: JSON.stringify(contactEmails) },
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    setDiscussions(Array.isArray(response.data) ? response.data : []);
  } catch (err) {
    console.error('Erreur chargement discussions:', err);
    setDiscussions([]);
  } finally {
    setLoadingDiscussions(false);
  }
}, [API_URL, token]);

useEffect(() => { fetchDiscussions(); }, [fetchDiscussions]);


useEffect(() => {
  const t = setTimeout(preloadDiscussionChunk, 1500);
  return () => clearTimeout(t);
}, []);


useEffect(() => {
  const reload = () => { fetchDiscussions(); };
  window.addEventListener('socket-reconnected', reload);
  return () => window.removeEventListener('socket-reconnected', reload);
}, [fetchDiscussions]);

 

useEffect(() => {
  if (!discussions.length || !userId) return;

  // Ne (re)déchiffre que les discussions pas encore résolues, pour éviter
  // de refaire le travail à chaque re-render de la liste.
  const toDecrypt = discussions.filter(d => decryptedTitles[d._id] === undefined);
  if (!toDecrypt.length) return;

  (async () => {
    const results = await Promise.all(
      toDecrypt.map(async (d) => {
        const { title } = await decryptDiscussionFields(d, socket, userId);
        return [d._id, title];
      })
    );
    setDecryptedTitles(prev => {
      const next = { ...prev };
      for (const [id, title] of results) next[id] = title;
      return next;
    });
  })();
}, [discussions, userId, decryptedTitles]);

  const handleAccept = async (discussionId) => {
    if (!userId) {
  console.error("Utilisateur non identifié");
  return;
}
    try {
      await api.post(`${API_URL}/api/users/accept-invitation`, {
        discussionId,
      });
      fetchDiscussions(); // Rechargement des discussions
setNotifications(prevNotifications => 
      prevNotifications.filter(invite => invite.discussionId !== discussionId)
    );
    } catch (error) {
      console.error("Erreur lors de l'acceptation :", error);
    }
  };


  const handleIgnore = async (discussionId) => {
    if (!userId) {
  console.error("Utilisateur non identifié");
  return;
}

    try {
      await api.post(`${API_URL}/api/users/${userId}/ignore-invitation`, {
        discussionId,
      });
      fetchDiscussions(); // Rechargement des discussions
setNotifications(prevNotifications => 
      prevNotifications.filter(invite => invite.discussionId !== discussionId)
    );
    } catch (error) {
if ([404, 409, 410].includes(error.response?.status)) {
      removeInvitationCard(discussionId);
      await prompt.alert(t('inviter.invitation_annulee_generique'));
      return;
    }

      console.error("Erreur lors de l'ignorance :", error);
    }
  };

  const navigateToProfile = (creatorId) => {
    navigate(`/profile/${creatorId}`);
  };

useEffect(() => {
  if (!selectedDiscussion) return;

  const updated = discussions.find((d) => d._id === selectedDiscussion._id);
  if (
    updated &&
    new Date(updated.updatedAt) > new Date(selectedDiscussion.updatedAt)    
  ) {
    setSelectedDiscussion(updated);
  }
}, [discussions]);


// 🖱️ Gestion de la sélection
const handleSelectDiscussion = (discussion) => {
 
    if (selectedDiscussion && selectedDiscussion._id === discussion._id) {
      // Si on reclique sur la même → on referme
      setSelectedDiscussion(null);
    } else {
window.__openSeq = (window.__openSeq || 0) + 1;
window.__t0 = performance.now();

//console.log('[open] clic, cache =', !!messagesCache[d._id]);
      // Sinon, on ouvre la discussion sélectionnée
      setSelectedDiscussion(discussion);
    }
  };

  const handleDiscussionCreated = (newDiscussion) => {
    setDiscussions((prev) => [...prev, newDiscussion]);
    //setShowForm(false);
  };

  const handleDiscussionDeleted = (deletedId) => {
    setDiscussions((prev) =>
      prev.filter((discussion) => discussion._id !== deletedId)
    );

    if (selectedDiscussion && selectedDiscussion._id === deletedId) {
      setSelectedDiscussion(null);
    }
  };


const handleDiscussionPublicDeleted = async (discussionId) => {
const { alert, confirm} = prompt;


  const confirmation = await confirm(t('discussion.alertdeletediscussion'));

  if (confirmation) {
    try {
      const token = localStorage.getItem('token');
      await api.delete(`${API_URL}/api/discussions/${discussionId}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
        withCredentials: true
      });
// ➕ Notifie les autres utilisateurs via le socket
socket.emit("user_delete_discussion", {
      discussionId,
      userId: user._id
    });       

    setDiscussions(prev => prev.filter(d => d._id !== discussionId));
  if (selectedDiscussion && selectedDiscussion._id === discussionId) {
    setSelectedDiscussion(null);
  }
  const { alert, confirm} = prompt;
      await alert(t('discussion.deletediscussionsucces'));
    } catch (error) {
      console.error('Erreur lors de la suppression de la discussion', error);
      await alert(t('discussion.deletediscussionerror'));
    }
  }
};


useEffect(() => {
  if (!socket) return;
const handleMemberRemoved = ({ discussionId, userId }) => {

    setDiscussions(prev =>
      prev.map(d =>
        d._id === discussionId
          ? {
              ...d,
              participants: d.participants.filter(
                p => String(p) !== String(userId)
              )
            }
          : d
      )
    );
  };
socket.on("discussion_member_removed", handleMemberRemoved);
return () => {
socket.off("discussion_member_removed", handleMemberRemoved);
  };
}, [socket]);

useEffect(() => {
  if (!socket) return;

  const handleDeleted = ({ discussionId }) => {
    setDiscussions((prev) => prev.filter((d) => d._id !== discussionId));
    if (selectedDiscussion && selectedDiscussion._id === discussionId) {
      setSelectedDiscussion(null);
    }
  };

const handlePublicDeleted = ({ discussionId }) => {
    setDiscussions((prev) => prev.filter((d) => d._id !== discussionId));
    if (selectedDiscussion && selectedDiscussion._id === discussionId) {
      setSelectedDiscussion(null);
    }
  };


const handleUpdate = ({ updatedDiscussion }) => {
    const id = updatedDiscussion._id;

    setDiscussions(prev =>
      prev.map(d => d._id === id ? { ...d, ...updatedDiscussion } : d)
    );

    setSelectedDiscussion(prev =>
      prev && prev._id === id
        ? { ...prev, ...updatedDiscussion }
        : prev
    );
  };

  socket.on('discussion_deleted', handleDeleted);
socket.on('user_delete_discussion', handlePublicDeleted);
socket.on("user_update_discussion", handleUpdate);
  return () => {
    socket.off('discussion_deleted', handleDeleted);
socket.off('user_delete_discussion', handlePublicDeleted);
socket.off("user_update_discussion", handleUpdate);
  };
}, [socket, selectedDiscussion]);

const formatDate = (isoDate, language = 'fr') => {
  const date = new Date(isoDate);

  const locales = {
    fr: 'fr-FR',
    en: 'en-US',
    de: 'de-DE',
    es: 'es-ES',
    pt: 'pt-PT',
    it: 'it-IT',
    hu: 'hu-HU',
    uk: 'uk-UA',
    sv: 'sv-SE',
    nl: 'nl-NL',
    fi: 'fi-FI',
    pl: 'pl-PL',
    ro: 'ro-RO',
    el: 'el-GR',
    no: 'no-NO',
    da: 'da-DK',
    cs: 'cs-CZ',
    sk: 'sk-SK',
    hr: 'hr-HR',
    lt: 'lt-LT',
    et: 'et-EE',
    lv: 'lv-LV',
    bg: 'bg-BG',
    sl: 'sl-SI',
    sr: 'sr-RS',
    is: 'is-IS',
    ar: 'ar-AR',
    mt: 'mt-MT',

  };

  const locale = locales[language] || 'fr-FR'; // fallback par défaut

  const formattedDate = date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });

  return formattedDate;
};

const language = i18n.language;

const handleLeaveMemo = useCallback((discussionId) => {
  setSelectedDiscussion(null);

  setDiscussions(prev =>
    prev.filter(d => d._id !== discussionId)
  );
}, [setDiscussions, setSelectedDiscussion]);

const isMemberSelected = useMemo(() => {
  if (!selectedDiscussion || !userId) return false;

  const fullDiscussion = discussions.find(
    d => String(d._id) === String(selectedDiscussion._id)
  );

  if (!fullDiscussion || !Array.isArray(fullDiscussion.participants)) {
    return false;
  }

  return fullDiscussion.participants.some(p =>
    String(p?._id || p) === String(userId)
  );
}, [discussions, selectedDiscussion, userId]);

if (!userObj || !userObj.email) {
    //console.error("❌ avant return, userObj est undefined ou n'a pas d'email");
    return null;
  }



const filteredContacts = contacts.filter(c => c.email !== userObj?.email);


return (
  <div className="list-discussion">
   {Array.isArray(notifications) && notifications.length > 0  && (
  <ul style={{ listStyle: 'none', margin: '0 0 8px 0', padding: '0 8px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
    {notifications.map((notif, index) => (
      <li key={index} style={{
        background: 'var(--input-bg)',
        border: '1px solid rgba(0,123,255,0.2)',
        borderLeft: '3px solid #007bff',
        borderRadius: '10px',
        padding: '10px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
      }}>
        {/* Icône */}
        <i className="ti ti-mail" style={{ fontSize: '20px', color: '#007bff', flexShrink: 0 }} aria-hidden="true" />

        {/* Texte */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ margin: 0, fontSize: '13px', color: 'var(--text-color)', lineHeight: 1.4 }}>
            <strong>{notif.inviterName}</strong>
            {' '}{t('discussionlist.invitation')}{' '}
            <em style={{ color: '#007bff' }}>"{notif.discussionTitle}"</em>
          </p>
        </div>

        {/* Boutons */}
        <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
          <button
            disabled={!userId}
            onClick={() => handleAccept(notif.discussionId)}
            title={t('discussionlist.acceptinvitation')}
            style={{
              background: 'rgba(46,204,113,0.12)',
              border: '1px solid rgba(46,204,113,0.4)',
              borderRadius: '8px',
              padding: '5px 8px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              fontSize: '12px',
              color: '#2ecc71',
            }}
          >
            <i className="ti ti-check" style={{ fontSize: '14px' }} aria-hidden="true" />
            {t('discussionlist.acceptinvitation')}
          </button>
          <button
            disabled={!userId}
            onClick={() => handleIgnore(notif.discussionId)}
            title={t('discussionlist.ignoreinvitation')}
            style={{
              background: 'rgba(231,76,60,0.08)',
              border: '1px solid rgba(231,76,60,0.3)',
              borderRadius: '8px',
              padding: '5px 8px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              fontSize: '12px',
              color: '#e74c3c',
            }}
          >
            <i className="ti ti-x" style={{ fontSize: '14px' }} aria-hidden="true" />
            {t('discussionlist.ignoreinvitation')}
          </button>
        </div>
      </li>
    ))}
  </ul>
)}

    {/* Supprimer l'ancien bouton +/- du header */}
{/* Supprimer le {showForm && <CreateDiscussion .../>} inline */}

{/* FAB flottant — à placer juste avant la fermeture du conteneur principal */}
  <>
    <button
      className="fab-new-discussion"
      onClick={() => setShowForm(true)}
      aria-label="Nouvelle discussion"
    >
      <i className="ti ti-plus" aria-hidden="true" />
    </button>

    {showForm && (
      <div className="fab-overlay" onClick={() => setShowForm(false)}>
        <div className="fab-modal" onClick={(e) => e.stopPropagation()}>
          <div className="fab-modal-handle" />
          <CreateDiscussion
            onDiscussionCreated={handleDiscussionCreated}
            onOpenDiscussion={setSelectedDiscussion}
            prompt={prompt}
            showForm={showForm}
            setShowForm={setShowForm}
          />
        </div>
      </div>
    )}
  </>


    {/* Liste des discussions */}
 {!selectedDiscussion && (
    <ul className="item_dicussion fade-in">
      {discussions.length === 0 ? (
        loadingDiscussions ? (
          <li className="li_item_dicussion info-message">Chargement...</li>
        ) : (
          <li className="li_item_dicussion info-message">{t('discussionlist.listempty')}</li>
        )
      ) : (
        discussions.map(discussion => {
const participants = discussion.participants || [];
    const isMember = participants.some(p =>
  String(p._id || p) === userId
);
 
return (
          <li key={discussion._id} className="li_item_dicussion">
            <div
              className="discussionItem"
              onClick={() => handleSelectDiscussion(discussion)}
            >
              <div className="leftContent">
                <img
                  src={
                    discussion.creator?.profileImage
                      ? `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${discussion.creator._id}?token=${token}&type=image&thumb=true&profile=true&t=${discussion.creator.profileImageUpdatedAt || 0}`
                      : `${API_URL}/uploads/default-profile.png`
                  }
                  alt="Photo"
                  className="discussionImage"
                  onClick={e => {
                    e.stopPropagation();
                    navigateToProfile(discussion.creator._id);
                  }}
                  style={{ cursor: 'pointer' }}
                />
                <div className="discussionInfo">
                  <span className="discussionCreator">{discussion.creator?.username}</span>
                  <span className="discussionTitle">
  {discussion.isPublic
    ? discussion.title
    : (decryptedTitles[discussion._id] ?? '…')}
</span>

{/* ✅ Aperçu dernier message */}
          {(() => {

  const {
    senderName,
    preview
  } = decryptedPreviews[discussion._id] || {
    senderName: '',
    preview: ''
  };

  if (!senderName && !preview) {
    return null;
  }

  return (
    <span className="discussionLastMessage">
      <strong>{senderName}</strong>
      {senderName ? ' : ' : ''}
      {preview}
    </span>
  );

})()}

                </div>
              </div>
	<div className="right-block">
		{discussion.isPublic && (


  <span className="ispublic" style={{ display: 'flex', alignItems: 'center' }}>

 
      <DiscussionInfoModal
        discussion={discussion}
        API_URL={API_URL}
        token={token}
      />
    
  </span>

)}

              <span className="date">{formatDate(discussion.createdAt, language)}</span>
	</div>
            </div>
          </li>
);
        })
      )}
    </ul>
)}
    {/* Fullscreen Discussion */}
    {selectedDiscussion && (
      <div className="discussion-fullscreen show">
       {/* {messagesCache[selectedDiscussion._id] ? ( */}
{loadingDiscussion ? (
      <SkeletonDiscussion />
    ) : null}
        
<div style={{ display: loadingDiscussion ? 'none' : 'block', height: '100%' }}>
          <Discussion
            discussion={selectedDiscussion}
	    selectedDiscussion={selectedDiscussion}
	    setSelectedDiscussion={setSelectedDiscussion}
	    discussionName={selectedDiscussion.title}
            discussionId={selectedDiscussion._id}
	    description={selectedDiscussion.description}
	    allowComments={selectedDiscussion.allowComments}
            messages={[]}
            onDiscussionDeleted={handleDiscussionDeleted}
	    onDiscussionPublicDeleted={handleDiscussionPublicDeleted}
	    onNewMessage={handleNewMessagePreview}
	    onMessageDeleted={handleDeletedMessagePreview}
	    onMessageUpdated={handleMessageUpdatedPreview}
	    onLoadStart={handleDiscussionLoadStart}   
            onLoadEnd={handleDiscussionLoadEnd}       
            userObj={userObj}
            socket={socket}
            prompt={prompt}
            setCallInProgress={setCallInProgress}
            contacts={contacts}
            setContacts={setContacts}
	    isPublic={selectedDiscussion.isPublic}
	    onDiscussionPublicLeave={handleLeaveMemo}
	    isMemberSelected={isMemberSelected}
	    onLeave={() => handleLeaveMemo(selectedDiscussion._id)}
	    openAgenda={openAgenda}
	    setOpenAgenda={setOpenAgenda}
  	    highlightEventId={highlightEventId}
	    setHighlightEventId={setHighlightEventId}
	    initialMessages={messagesCache[selectedDiscussion._id]}
	    

          />
	</div>
       
      </div>
    
)}
    {/* Footer des utilisateurs en ligne */}
    {user && (
      <OnlineUsersFooter
        contacts={filteredContacts}
        socket={socket}
        currentUserEmail={user.email}
        onStatusChange={handleStatusChange}
      />
    )}
  </div>
);


};

export default DiscussionList;
